const isDropdownOptionSelected = (selectedOptions: string[], dropdownOption: string) => {
  if (selectedOptions.includes(dropdownOption)) return true;
  return false;
};

export default isDropdownOptionSelected;
